module.exports = __webpack_public_path__ + "img/banner-main-m.3f630fb1.png";